var FilterUsersModule = /** @class */ (function () {
    function FilterUsersModule() {
    }
    return FilterUsersModule;
}());
export { FilterUsersModule };
